const initState = {
  "addInputOpen": false,
  "addOutputOpen": false,
  "addAudioNodeOpen": false,
  "editAudioNodeOpen": false,
  "editAudioNodeId": null,
  drawingConnection: false,
  drawingConnectionNodeId: null,
  helpOpen: false,
  permissionsModalOpen: false,
  persistent: {
    hasSeenHelp: false
  }
};
export default initState;